import { render, staticRenderFns } from "./products-list-item-supplier.vue?vue&type=template&id=6f1a13c2"
import script from "./products-list-item-supplier.vue?vue&type=script&lang=js"
export * from "./products-list-item-supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports